module.exports = __webpack_public_path__ + "static/media/HCMM720.b08d47fd.jpg";